import React, { useRef, useEffect } from 'react';
import Modal from 'cccisd-modal';
import { useParams } from 'cccisd-react-router';
import axios from 'cccisd-axios';
import PropTypes from 'prop-types';
import Tooltip from 'cccisd-tooltip';
import { useDispatch, useSelector } from 'react-redux';
import notification from 'cccisd-notification';

import { getProducts } from '../../../../reducers/products';
import LearnerForm from '../../../../components/Manage/LearnerForm';

import IconPencil from 'cccisd-icons/pencil';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;
const userRole = Fortress.user.acting.role.handle;
const isUberAdmin = userRole === 'uberadmin';

const EditLearnerForm = props => {
    const { productHandle } = useParams();
    const modal = useRef();
    const dispatch = useDispatch();

    !isUberAdmin &&
        useEffect(() => {
            (async () => {
                dispatch(getProducts(productHandle));
            })();
        }, [dispatch]);

    const { productId } = useSelector(state => state.app.products);

    // rows are coming from each role's learner_tableMain.graphql
    const { row, settings, loadData } = props;

    const getPawnIds = list => {
        return list && list.length > 0
            ? list.map(l => {
                  return l.pawn.pawnId;
              })
            : [];
    };

    const onSubmit = async values => {
        const response = await axios.put(
            Boilerplate.route('api.nexus.pawn.update', {
                pawn: row['pawn.pawnId'],
            }),
            {
                pawnHash: row['pawn.pawnHash'],
                productId,
                participantName: values.participantName,
                participantId: values.participantId,
                gender: values.gender,
                grade: values.grade,
                teacherName: values.teacherName,
                teacherEmail: values.teacherEmail,
                teacherPhone: values.teacherPhone,
                parentEmail: values.parentEmail,
                parentPhone: values.parentPhone,
                group: values.school,
                parentPawns: values.allClassesAnyProduct,
            }
        );

        if (response.data.errors) {
            return Promise.reject(response.data.errors);
        }
        await loadData();
        notification('Learner edited.');
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <Tooltip title="Edit">
                    <button type="button" className="btn btn-xs btn-success">
                        <IconPencil />
                    </button>
                </Tooltip>
            }
            title={`Edit ID Number ${row['fields.participantId']}`}
        >
            <LearnerForm
                operation="edit"
                onSubmit={onSubmit}
                initialValues={{
                    productId: isUberAdmin ? row['parentRoles.class.fields.productId'] : productId,
                    otherProductsClasses: getPawnIds(row['otherProductsClasses.classList']),
                    group: row['parentRoles.class.pawn.pawnId'],
                    school: row[settings.school],
                    participantName: row['fields.participantName'],
                    participantId: row['fields.participantId'],
                    gender: row['fields.gender'],
                    grade: row['fields.grade'],
                    teacherName: row['fields.teacherName'],
                    teacherEmail: row['fields.teacherEmail'],
                    teacherPhone: row['fields.teacherPhone'],
                    parentEmail: row['fields.parentEmail'],
                    parentPhone: row['fields.parentPhone'],
                }}
                {...props}
                productId={productId}
            />
        </Modal>
    );
};

EditLearnerForm.propTypes = {
    loadData: PropTypes.func,
    row: PropTypes.object,
};

export default EditLearnerForm;
